import {GuidesEnum, ProfileEnum} from 'presentation/constants';
import {usePersonalData} from 'presentation/hooks';
import {useState} from 'react';
import {useLocation, useNavigate} from 'react-router-dom';
import {emailHandler} from '../../utils/emailHandler';
import {phoneHandler} from '../../utils/phoneHandler';
import {UseSimpleConfirmationDrawerProps} from './types';

const useSimpleConfirmationDrawer = ({
	handleConfirmAndContinue,
	handleClose,
}: UseSimpleConfirmationDrawerProps) => {
	const navigate = useNavigate();
	const {pathname} = useLocation();
	const {currentPhone, currentEmail} = usePersonalData();
	const phone = phoneHandler(currentPhone);
	const email = emailHandler(currentEmail);
	const [openAlert, setOpenAlert] = useState<boolean>(false);

	const handleUpdateInfo = () => {
		handleClose();
		navigate(ProfileEnum.PROFILE, {
			state: pathname === GuidesEnum.SERVICE_NETWORK_HEALTH ? undefined : pathname,
		});
	};

	const hasMissingInfo = !phone.hasValue || !email.hasValue;
	const hasInvalidInfo = phone.invalidValue || email.invalidValue;
	const shouldOpenAlert = hasMissingInfo || hasInvalidInfo;

	const handleOpenAlert = () => {
		setOpenAlert(true);
	};

	const handleCloseAlert = () => {
		setOpenAlert(false);
	};

	const handleContinue = () => {
		if (shouldOpenAlert) {
			handleOpenAlert();
			return;
		}
		handleClose();
		handleConfirmAndContinue();
	};

	return {
		phone,
		email,
		handleUpdateInfo,
		handleContinue,
		handleCloseAlert,
		openAlert,
	};
};

export {useSimpleConfirmationDrawer};
